/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HouseholdKind } from './householdKind';

/**
 * Relevant data concerning the household of the partner.   (bipro-partner::Haushalt)
 */
export interface Household {
  householdKind?: HouseholdKind;
  /**
   * Number of children in household.
   */
  numberOfChildren?: number;
  /**
   * Birthday of the youngest child in household.   (german: Geburtsdatum jüngstes Kind)
   */
  birthdayYoungestChild?: string;
  /**
   * Birthday of the oldest child in household.   (german: Geburtsdatum ältestes Kind)
   */
  birthdayOldestChild?: string;
  /**
   * Number of motor vehicles in household, including the insured vehicle.
   */
  numberOfVehicles?: number;
  /**
   * Number of motor vehicles in household, which are already insured at Verti.
   */
  numberOfVehiclesVerti?: number;
}
export namespace Household {}
